import { useLocation } from 'react-router-dom';
import { getBreadcrumbs } from 'Components/Breadcrumbs';
import { selectAdditionalParams } from 'Selectors';
import { useSelector } from 'react-redux';

function useBreadcrumbs() {
    const location = useLocation();
    const additionalParams = useSelector(selectAdditionalParams);
    const breadcrumbs = getBreadcrumbs(location);

    breadcrumbs?.breadcrumbs?.forEach((breadcrumb) => {
        if (breadcrumb.hasAdditionalParams) {
            const params = additionalParams[breadcrumb.actualPath];
            breadcrumb.params = { ...breadcrumb.params, ...params };
        }
    });

    return breadcrumbs;
}

export default useBreadcrumbs;
